import { render, staticRenderFns } from "./MultiMovies.vue?vue&type=template&id=84468abc&scoped=true&"
import script from "./MultiMovies.vue?vue&type=script&lang=ts&"
export * from "./MultiMovies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84468abc",
  null
  
)

export default component.exports